import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const sandboxShellWeb: PluginWebManifest = {
  // sandbox-shell is a no-page plugin — it only contributes a
  // "Shell" agent tab. The overview card is written by hand so
  // the plugin detail page renders a rich About section; `to`
  // targets the canonical plugin detail page since there is no
  // standalone page to deep-link to.
  overviewCards: [
    {
      to: '/org/plugins/sandbox-shell',
      label: 'Sandbox Shell',
      icon: 'TerminalSquare',
      description: 'Interactive PTY shells on every agent devbox.',
      details:
        'Opens a Shell tab on every agent backed by a real Runloop PTY session on the devbox. Sessions survive page reloads for the life of the devbox, so you can run commands, inspect process state, and pick up where you left off without losing scrollback or a long-running command.',
      features: [
        '"Shell" tab on every agent detail page',
        'Real PTY sessions backed by Runloop',
        'Sessions survive page reloads for the life of the devbox',
        'Multiple concurrent shells via tabs',
        'Full ANSI / scrollback support',
      ],
      group: 'plugins',
    },
  ],
  agentTabs: [
    {
      id: 'sandbox-shell',
      label: 'Shell',
      icon: 'TerminalSquare',
      componentPath: '@reflex/plugin-sandbox-shell/web/SandboxShellTab',
    },
  ],
  marketingPreviews: [
    {
      id: 'sandbox-shell-panel',
      label: 'Sandbox shell agent panel',
      description:
        'The "Shell" tab that appears on every agent — switch between multiple persistent PTY sessions on the agent\'s devbox with live terminal output and a connection indicator.',
      surface: 'panel',
      componentPath: '@reflex/plugin-sandbox-shell/web/SandboxShellTabPreview',
    },
  ],
};
